import React, { Component } from 'react';  
import Util from "../../util.js";
import { setStorage, getStorage } from '../../common'; 
import { Picker, List } from 'antd-mobile/lib';
import CalculatorLine from "./CalculatorLine.js";
import { connect } from 'react-redux';
import { getPayAll, goLogin } from '../../getPay';
import NavigatorMain from '../NavigatorMain.js';
import ModalSelect from '../Modal/ModalSelect';
import { hashHistory } from 'react-router';
import NullView from "../NullView.js";
import {getCondition, yljyPlan, yljyNum, yljyAllMoney, yljyLineData} from '../../action/investmentAction.js';

class PensionCalculatorPlan extends Component { 
  state = {
    planType: this.props.yljyPlan,
    startNum: this.props.yljyNum,
    nowMoney: this.props.yljyAllMoney,
    nowYear: 65-this.props.location.state.theParams.theAge,
    lineArray: this.props.yljyLineData,
    addflag: false
  } 

  componentWillMount() {
    document.getElementsByTagName('title')[0].innerHTML = "投资方案";
    let { theParams } = this.props.location.state;
    let { planType } = this.state;
    let { dispatch }=this.props;
    let code;
    if(theParams.theAge <= 37) {
      code='SF1008';
    }else if(theParams.theAge >= 38 && theParams.theAge < 47) {
      code='SF1007';
    }else if(theParams.theAge >= 48 && theParams.theAge < 65) {
      code='SF1006';
    }
    let data1 = {superFundCode:code }
    if(theParams.gap < 0) {
      this.getMoney(theParams.yqylj/2, 25, planType, this.state.startNum);
    }else {
      this.getMoney(theParams.gap, 25, planType, this.state.startNum);
    }
  }
  getMoney = (yearGap, N, planType, startNum) => {
    let { dispatch } = this.props;
    this.setState({
      lineArray: null
    });
    dispatch(yljyLineData(null));
    let thisO = this;
    setTimeout(() => {
      let { nowYear } = thisO.state;
      let r = 0.03;
      let r2 = 1/(1+r);
      let totalGap = yearGap * ((1-Math.pow((r2), N)) / (1-(r2)));
      let rate;
      if(planType == "每月投资方案") {
        if(startNum[0] == "沪深300，年化8%") {
          rate = Math.pow ( (0.08+1), 1/12) -1;
        }else if(startNum[0] == "中债综合财富指数，年化4.2%") {
          rate = Math.pow ( (0.042+1), 1/12) -1;
        }else if(startNum[0] == "标普500，年化7%") {
          rate = Math.pow ( (0.07+1), 1/12) -1;
        }
        thisO.PMT(rate, nowYear*12, 0, totalGap);
      }else if(planType == "一次投资方案") {
        if(startNum[0] == "沪深300，年化8%") {
          rate = 0.08;
        }else if(startNum[0] == "中债综合财富指数，年化4.2%") {
          rate = 0.042;
        }else if(startNum[0] == "标普500，年化7%") {
          rate = 0.07;
        }
        thisO.PV(rate, nowYear, totalGap);
      }
    });
  } 

  PMT = (ir, np, pv, fv ) => {
   let { dispatch } = this.props;
   var pmt = ( ir * ( pv * Math.pow ( (ir+1), np ) + fv ) ) / ( ( ir + 1 ) * ( Math.pow ( (ir+1), np) -1 ) );
   this.setState({
    nowMoney: pmt.toFixed(2)
   });
   dispatch(yljyAllMoney(pmt.toFixed(2)));
   this.getProfitCurve4PMT(pmt, np, ir);
  }

  PV = (ir, np, fv) => {
    let { dispatch } = this.props;
    var pv = fv / (Math.pow((1+ir), np));
    this.setState({
      nowMoney: pv.toFixed(2)
    });
    dispatch(yljyAllMoney(pv.toFixed(2)));
    this.getProfitCurve4PV(pv, np, ir);
  }

  getProfitCurve4PV = (pv, n, r) => { 
    let { dispatch } = this.props;
    let c = []; 
    for(let i=0; i<=n; i++) { 
      c[i] = (pv * Math.pow((1+r), i)*0.0001).toFixed(2); 
    } 
    this.setState({
      lineArray: c
    });
    dispatch(yljyLineData(c));
  }

  getProfitCurve4PMT = (pmt, n, r) => { 
    let { dispatch } = this.props;
    let c = []; 
    for(let i=0; i<=n; i++){ 
      if(i===0) { 
        c[i] = (pmt*0.0001).toFixed(2); 
      }
      else {
        c[i] = (c[i-1]*(1+r) + pmt*0.0001).toFixed(2); 
      } 
    }
    this.setState({
      lineArray: c
    });
    dispatch(yljyLineData(c));
  }

  changeStartNum = (value) => {
    let { dispatch } = this.props;
    let { theParams } = this.props.location.state;
    let { planType } = this.state;
    this.setState({
      startNum: value
    });
    dispatch(yljyNum(value));
    if(theParams.gap < 0) {
      this.getMoney(theParams.yqylj/2, 25, planType, value);
    }else {
      this.getMoney(theParams.gap, 25, planType, value);
    }
  }

  changePlan = (value) => {
    let { dispatch } = this.props;
    let { theParams } = this.props.location.state;
    this.setState({
      planType: value
    });
    dispatch(yljyPlan(value));
    if(theParams.gap < 0) {
      this.getMoney(theParams.yqylj/2, 25, value, this.state.startNum);
    }else {
      this.getMoney(theParams.gap, 25, value, this.state.startNum);
    }
  }
  goBack = () => {
    hashHistory.goBack();
  }
  goInvestMain = () => {
    hashHistory.push({
      pathname: "/nullView"
    });
  }
  goDetail = () => {
    let { userHasInvested, inNeedUpdate, dispatch } = this.props;
    let { theParams } = this.props.location.state;
    let code;
    if(theParams.theAge <= 37) {
      code='SF1008';
    }else if(theParams.theAge >= 38 && theParams.theAge < 47) {
      code='SF1007';
    }else if(theParams.theAge >= 48 && theParams.theAge < 65) {
      code='SF1006';
    }
    hashHistory.push({
      pathname: "/SuperFundDetail",
      state: {
        superFundCode: code
      }
    });
  }
  goPayDetail = (event) => {
    event.stopPropagation();
    let {  dispatch } = this.props;
    let route=window.history.length;
    let { theParams } = this.props.location.state;
    let code, name;
    if(theParams.theAge <= 37) {
      code='SF1008';
      name='80后智领未来';
    }else if(theParams.theAge >= 38 && theParams.theAge < 47) {
      code='SF1007';
      name='70后智赢人生';
    }else if(theParams.theAge >= 48 && theParams.theAge < 65) {
      code='SF1006';
      name='60后智享财富';
    }
    let data={superFundCode:code}
    const fun=function(){   
      let params={
        fundCode:code,
        fundName:name,
        productType: "Z",
        pageText: "申购",
        superTypeValue: "0"
      }
      getPayAll(route,params,hashHistory,'PaymentAllSuperFund')
    }
    goLogin(fun,window.history.length);
  }
  ok(){
    hashHistory.push({
        pathname:'/paymentSuperFund',
    })
  }
  render() { 
    let { theParams } = this.props.location.state;
    let { planType, startNum, nowYear, nowMoney, lineArray } = this.state;
    let startNumArray = [{value: "沪深300，年化8%", label: "沪深300，年化8%"}, {value: "中债综合财富指数，年化4.2%", label: "中债综合财富指数，年化4.2%"}, {value: "标普500，年化7%", label: "标普500，年化7%"}];
    let textList = [];
    let imgIcon = [];
    let textList2 = [];
    if(theParams.theAge <= 37) {
      textList.push(
        <div key={0} style={{fontSize: 15, color: "#ff9536"}}>80后智领未来</div>
      );
      textList2.push(
        <div key={0} style={{fontSize: 12, color: "#5b6470", marginTop: 8}}>投资未来 财富启航</div>
      );
      imgIcon.push(
        <img
        key={0}
        style={{width: 121, height: 85}}
        src={require("../../img/blhylIcon.png")}
        />
      );
    }else if(theParams.theAge >= 38 && theParams.theAge < 47) {
      textList.push(
        <div key={0} style={{fontSize: 15, color: "#ff9536"}}>70后智赢人生</div>
      );
      textList2.push(
        <div key={0} style={{fontSize: 12, color: "#5b6470", marginTop: 8}}>均衡配置 稳健升值</div>
      );
      imgIcon.push(
        <img
        key={0}
        style={{width: 121, height: 85}}
        src={require("../../img/qlhylIcon.png")}
        />
      );
    }else if(theParams.theAge >= 48 && theParams.theAge < 65) {
      textList.push(
        <div key={0} style={{fontSize: 15, color: "#ff9536"}}>60后智享财富</div>
      );
      textList2.push(
        <div key={0} style={{fontSize: 12, color: "#5b6470", marginTop: 8}}>追求长期 稳定收益</div>
      );
      imgIcon.push(
        <img
        key={0}
        style={{width: 121, height: 85}}
        src={require("../../img/jjzhIcon.png")}
        />
      );
    }
    return (  
      <div style={{
        backgroundColor:'rgba(242,245,247,1)', 
        display: "-webkit-flex", 
        WebkitFlexDirection: "column", 
        height: "100%"
      }}>  
      <ModalSelect go={()=>this.ok()} />
        <NavigatorMain>
          <div className="bgChange" style={{backgroundSize: "cover", width: window.winWidth, height: 44}}>
            <div style={{display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
              <div style={{width: 100}}>
                <img onClick={this.goBack}  alt="" style={{height: 40, width: 40}} src={require("../../img/leftArrow_header.png")} />
              </div>
              <div style={{fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center"}}>投资方案</div>
              <div style={{fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right"}}><span onClick={this.goInvestMain}>跳过</span></div>
            </div>
          </div>
        </NavigatorMain>
        <div style={{overflow: "auto", overflowX: "hidden", WebkitFlex: 1}}>
          <div  className="bgChange2" style={{backgroundSize: "cover",width: window.winWidth, height: "auto", paddingBottom: 20}}>
            <div style={{
              width: window.winWidth,
              paddingLeft: 13,
              paddingRight: 13,
              WebkitFlexDirection: "row",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              display: "-webkit-flex"
            }}>
              <img
              style={{width: 63, height: 63}}
              src={require("../../img/jqrIcon.png")}
              />
              <div style={{paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth-96, borderRadius: 10}}>
                <span style={{
                  color: "#fff",
                  lineHeight: "16px",
                  fontSize: 13
                }}>根据您的情况，为您推荐以下两种投资方案，供参考。</span>
              </div> 
            </div>
          </div>
          <div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 10, paddingBottom: 10, backgroundColor: "#fff"}}>
            <span style={{display: "block", fontSize: "13px", color: "#5b6370", marginTop: 5, lineHeight: 1.5}}>温馨提示 : 投资方案为结合市场中代表性指数过去5年业绩进行计算的，试算结果并不代表您实际投资能够得到的收益。</span>
          </div>
          <div style={{display: "-webkit-flex", height: 45, width: window.winWidth, WebkitFlexDirection: "row", border: "1px solid #ebedf0", backgroundColor: "#fff", marginTop: 10}}>
            <div onClick={() => this.changePlan("每月投资方案")} style={planType == "每月投资方案" ? {borderBottom: "1px solid #ff9a96",width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"} : {width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <span style={planType == "每月投资方案" ? {color: "#3a3e47",color: "#5b6370", fontSize: 12} : {color: "#5b6370", fontSize: 12}}>每月投资方案</span>
            </div>
            <div onClick={() => this.changePlan("一次投资方案")} style={planType == "一次投资方案" ? {borderBottom: "1px solid #ff9a96",width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"} : {width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <span style={planType == "一次投资方案" ? {color: "#3a3e47",color: "#5b6370", fontSize: 12} : {color: "#5b6370", fontSize: 12}}>一次投资方案</span>
            </div>
          </div>
          <div>
            <div style={{display: "-webkit-flex", backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)"}}>
              <div style={{textAlign: "center"}}>
                <div style={{marginBottom: 5, color: "#5b6370", fontSize: "13px"}}>{planType == "每月投资方案" ? "每月投入" : "一次性投入"}</div>
                <div style={{fontSize: 20, color: "#ff935f", marginTop: 5}}>{nowMoney != null ? Util.parsePrice(nowMoney, false) : null}<span style={{fontSize: "13px", color: "#5b6370"}}> {nowMoney != null ? "元" : null}</span></div>
              </div>
              <div style={{height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)"}}></div>
              <div style={{textAlign: "center"}}>
                <div style={{marginBottom: 5, color: "#5b6370", fontSize: "13px"}}>持续投资</div>
                <div style={{fontSize: 20, color: "#3a3e47", marginTop: 5}}>{nowYear}<span style={{fontSize: "13px", color: "#5b6370"}}> 年</span></div>
              </div>
              <div style={{height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)"}}></div>
              <div style={{textAlign: "center"}}>
                <div style={{marginBottom: 5, color: "#5b6370", fontSize: "13px"}}>预期可新增养老金</div>
                <div style={{fontSize: 20, color: "#3a3e47", marginTop: 5}}>{theParams.gap < 0 ? (theParams.yqylj/2/12).toFixed(2) : Util.parsePrice((theParams.gap/12).toFixed(2), false)}<span style={{fontSize: "13px", color: "#5b6370"}}> 元／月</span></div>
              </div>
            </div>
            {
              lineArray != null ? 
              <CalculatorLine dataSource={lineArray} planType={planType} nowYear={nowYear} /> : 
              null
            }
            <div className="pickerBox" style={{
              display: "-webkit-flex",
              height: 45,
              borderTop: "1px solid rgb(235, 238, 240)",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              paddingLeft: 13,
              paddingRight: 5,
              backgroundColor: "#fff"
            }}>
              <Picker value={startNum} title="计算参考指数" extra={startNum[0]} data={startNumArray} onChange={this.changeStartNum} cols={1} className="forss">
                <List.Item arrow="horizontal">选择参考指数</List.Item>
              </Picker>
            </div>
          </div>
          <div onClick={this.goDetail} style={{display: "-webkit-flex", height: 117, backgroundColor: "#fff", marginTop: 10, paddingTop: 20, paddingBottom: 20, WebkitFlexDirection: "row"}}>
            <div style={{width: "60%", paddingLeft: 13}}>
              {
                textList
              }
              {
                textList2
              }
              <div onClick={this.goPayDetail} style={{display: "-webkit-flex", textAlign: "center", height: 25, width: 89, border: "1px solid #ff9536", marginTop: 15, borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                <span style={{fontSize: 12, color: "#ff9536"}}>一键投资</span>
              </div>
            </div>
            <div style={{display: "-webkit-flex", width: "40%", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              {
                imgIcon
              }
            </div>
          </div>
        </div>
      </div>  
    );  
  }  
}  
  
function mapStateToProps(state, ownProps) {
  return {
   userHasInvested:state.userHasInvested,
   inNeedUpdate:state.inNeedUpdate,
   yljyPlan: state.yljyPlan,
   yljyNum: state.yljyNum,
   yljyAllMoney: state.yljyAllMoney,
   yljyLineData: state.yljyLineData
  }
}

export default connect(mapStateToProps)(PensionCalculatorPlan);


// WEBPACK FOOTER //
// ./src/components/recommend/PensionCalculatorPlan.js